var DecodedObject =
/** @class */
function () {
  function DecodedObject(newPosition) {
    this.newPosition = newPosition;
  }

  DecodedObject.prototype.getNewPosition = function () {
    return this.newPosition;
  };

  return DecodedObject;
}();

export default DecodedObject;